import { koComponent } from "../../../../ko-utils";
import { getServerSideData } from "../../../page";
import ItemBase from "./itemBase";
//import lo from 'lodash'
import lo_groupBy from 'lodash/groupBy';
import lo_values from 'lodash/values';
import $api from '../../../../api/index';
//import ArticlesSelect from '../../../../../react/customer-center/components/ArticlesSelect';

class KbArticle extends ItemBase {
    constructor(params) {
        super(params, KbArticleOpts);

        //this.ArticlesSelectCmp = ArticlesSelect;

        //const languages = window.auth.project.SupportedLanguages;
        //const [defaultLanguage] = languages;
        this.selectedLanguage = params.selectedLanguage;

        this.processResults = (data) => {
            const articles = lo_groupBy(data, v => v.articleId);

            const aa = lo_values(articles).map(art => {
                let cnt = art.filter(i => i.language == ko.unwrap(this.selectedLanguage))[0];

                if (!cnt) {
                    cnt = art[0];
                }

                return cnt;
            });

            return aa.map(i => {
                const cats = [];

                if (i.categories) {
                    for (const strCat of i.categories) {
                        try {
                            var parsedCat = JSON.parse(strCat);

                            cats.push(parsedCat.filter(i => i.lng == ko.unwrap(this.selectedLanguage))[0].text)
                        } catch (e) { }
                    }
                }

                return {
                    value: i.id,
                    text: i.title,
                    data: {
                        subtext: cats.join(' > ')
                    }
                }
            });
        }

        this.preSelected = ko.observable();
        this.isChanging = ko.observable(false);

        this.articlesSearchOpts = {
            liveSearch: true,
            ajax: {
                url: '/api/v1/customer-center/' + window.auth.project.UniqueCode + '/articles/search-simple',
                type: 'GET',
                dataType: 'json',
                data: {
                    q: '{{{q}}}',
                    language: ko.unwrap(this.selectedLanguage)
                }
            },
            preprocessData: this.processResults
        }

        const opts = ko.unwrap(params.item.opts);

        if (ko.unwrap(opts.articleId)) {
            $api.customerCenter.getArticleContentById({ projectCode: window.auth.project.UniqueCode, id: ko.unwrap(opts.articleId) }, {}, (data) => {
                this.preSelected({
                    value: data.id,
                    text: data.title
                });
            });
        } else { // TODO: should be in editable mode if empty, but currently it's firing the dirty flag
            this.isChanging(true);
        }
    }

    editArticle() {
        this.isChanging(true);
    }
}

class KbArticleOpts {
    constructor(data) {
        if (!data) data = {};

        this.articleId = ko.observable(ko.unwrap(data.articleId)).extend({ trackChange: { name: 'KbArticleOpts.articleId' } });
    }
}

export default koComponent('btn-item-kb-article', KbArticle);